import { cloneDeep, get } from 'lodash'
import { capitalize } from '@/lib/generic.utils'
import EmailPreferencesMap from '@/lib/email-preferences.map'

export default {
  dataError: state => {
    return state.dataError
  },
  accessToken: state => {
    return state.accessToken
  },
  tenant: state => {
    return state.tenant
  },
  locale: state => {
    if (!state.settings) {
      return
    }
    return state.settings.locale
  },
  globalLoader: state => {
    return state.settings
  },
  originalEmailPreferences: state => state.emailPreferences,
  emailPreferences(state, getters) {
    const emailPref = cloneDeep(getters.originalEmailPreferences)
    return emailPref.map(item => ({
      label: get(EmailPreferencesMap, item.name, capitalize(item.name.replace('_', ' '))),
      value: item.id
    }))
  },
  hasPermission(state) {
    if (!state.user) return false
    const permissions = state.user.permissions
    return permission => permissions.some(p => p.name === permission)
  }
}
